import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import { StartMessagesContainer } from './RcsChat.styles';
import RcsStartMessage from './RcsStartMessage';

/**
 * @param {Boolean} isCreatingConversation - Loading state for creating conversation
 * @param {Array} preconfiguredMessages - List of preconfigured messages
 * @param {Function} onSendMessageClick - Callback function for using the
 * preconfigured message to start the chat
 */
const RcsStartChatMessages = ({
  isCreatingConversation,
  preconfiguredMessages,
  onSendMessageClick,
}) => {
  return (
    <StartMessagesContainer>
      {preconfiguredMessages.map(message => {
        return (
          <Box key={message}>
            <RcsStartMessage
              isCreatingConversation={isCreatingConversation}
              message={message}
              onSendMessageClick={onSendMessageClick}
            />
          </Box>
        );
      })}
    </StartMessagesContainer>
  );
};

export default RcsStartChatMessages;
